import { useParams } from 'react-router-dom';
import Breadcrumb from '../../components/common/Breadcrumb/Breadcrumb';
import ButtonIconOutlineMedium from '../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import SectionPrice from '../../components/detailproduct/SectionPrice/SectionPrice';
import SectionProductSummary from '../../components/detailproduct/SectionProductSummary/SectionProductSummary';
import { Icon } from '../../components/icon/icon';
import { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSaleProduct } from '../../store/actions/sale-product.action';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ButtonIconSolidLarge from '../../components/common/ButtonIconSolid/ButtonIconSolidLarge';
import { Radio } from 'antd';
import ButtonLink from '../../components/common/ButtonLink/ButtonLink';
import Tag from '../../components/common/Tag/Tag';
import ButtonPrimaryLarge from '../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import ButtonSecondaryLarge from '../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import SelectComponent from '../../components/common/SelectComponent/SelectComponent';
import SelectionBasic from '../../components/common/SelectionBasic/SelectionBasic';
import SectionVariants from './Components/SectionVariants';
import { Divider } from 'antd';
import SectionSummary from './Components/SectionSummary';
import SectionDetail from './Components/SectionDetail';
import SectionTopProduct from './Components/SectionTopProduct';

export const DetailProductPageContext = createContext();

const DetailSofaPage = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { detail } = useSelector(state => state.saleProduct);

  const [variant, setVariant] = useState();

  useEffect(() => {
    if (id) {
      dispatch(fetchSaleProduct({ id, country_code }));
    }
  }, [id]);

  const contextValue = {
    variant,
    setVariant,
  };

  if (detail.isLoading) return <Spin spinning={true} fullscreen={true} />;

  return (
    <DetailProductPageContext.Provider value={contextValue}>
      <div className="bg-primary-varient flex flex-col gap-0 relative left-0 right-0">
        <section className="flex pt-[16px] px-[80px] items-center gap-[16px]">
          <ButtonIconOutlineMedium
            icon={<Icon.ICArrowBack />}
            onClick={() => {
              navigate(-1);
            }}
          />
          <Breadcrumb
            items={[
              {
                title: t('Homepage'),
                href: '/',
              },
              {
                title: t('Product details'),
              },
            ]}
          />
        </section>
        {/* <SectionProductSummary />
      <SectionPrice />
      // <SectionDetail data={detail.data} />
      */}
        <SectionVariants />
        <SectionSummary />
        <SectionDetail data={detail.data} />
        <SectionTopProduct />
      </div>
    </DetailProductPageContext.Provider>
  );
};

export default DetailSofaPage;
